import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { ProjectLocationPlanModel } from '../../models/project-location-plan.model';

export const ProjectLocationPlanActions = createActionGroup({
  source: 'PROJECT_LOCATION_PLAN',
  events: {
    'Reset to Initial state': emptyProps(),

    'Load project location plans': props<{
      projectId: string;
    }>(),
    'Load project location plans success': props<{
      plans: ProjectLocationPlanModel.PlanDocument[];
    }>(),
    'Load project location plans fail': emptyProps(),

    'Set floor image': props<{
      planId: string;
      floorImageFileName: string | null;
      floorImageDataUrl: string | null;
    }>(),
    'Clear floor image': props<{
      planId: string;
    }>(),

    'Create project location plan': props<{
      projectId: string;
      locationId: string;
      plan: ProjectLocationPlanModel.API.CreatePlanDto;
    }>(),
    'Create project location plan success': props<{
      plan: ProjectLocationPlanModel.PlanDocument;
    }>(),
    'Create project location plan fail': emptyProps(),

    'Load selected plan': props<{
      planId: string;
    }>(),
    'Load selected plan success': props<{
      plan: ProjectLocationPlanModel.PlanDocument;
    }>(),
    'Load selected plan fail': emptyProps(),

    'Start copy plan': props<{
      planId: string;
    }>(),
    'Start copy plan Success': props<{
      plan: ProjectLocationPlanModel.PlanDocument;
    }>(),
    'Start copy plan Fail': emptyProps(),

    'Edit project location plan': props<{
      planId: string;
      data: ProjectLocationPlanModel.API.UpdatePlan;
    }>(),
    'Edit project location plan success': props<{
      plan: ProjectLocationPlanModel.PlanDocument;
    }>(),
    'Edit project location plan fail': emptyProps(),

    'Request delete plan': props<{
      planId: string;
    }>(),
    'Request delete plan cancel': emptyProps(),

    'Start delete plan': props<{
      planId: string;
    }>(),
    'Start delete plan success': emptyProps(),
    'Start delete plan fail': emptyProps(),

    'Upload project location plan floor image': props<{
      planId: string;
      uploadDto: ProjectLocationPlanModel.API.UploadPlanImage;
    }>(),
    'Upload project location plan floor image success': props<{
      plan: ProjectLocationPlanModel.PlanDocument;
    }>(),
    'Upload project location plan floor image fail': props<{
      planId: string;
    }>(),

    'Download plan picture': props<{
      floorImageUrl: string;
    }>(),

    'Download plan picture success': props<{
      image: Blob;
    }>(),

    'Download plan picture fail': emptyProps(),
  },
});
